import type { RootState } from 'state';
import { AirportsTo } from '../constants/filtersKeys';

function isFetchingAirportsToInProgress(state: RootState): boolean {
  const { fetching } = state.flightRoutes.filtersOptions;
  return fetching.indexOf(AirportsTo) !== -1;
}

export default isFetchingAirportsToInProgress;
